import React, { Component } from 'react';
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import { PageIntro } from '../components/StyledComponents'
import PostGrid from '../components/PostGrid'

export class Tags extends Component {
  render() {
    const { data, pathContext } = this.props
  
    return (
      <div>
        <Helmet title={`${pathContext.tag} | ${data.site.siteMetadata.title}`} />

        <PageIntro>
          <h1>{pathContext.tag}</h1>
        </PageIntro>

        <PostGrid data={data.posts} />
      </div>
    );
  }
}
export default Tags

export const query = graphql`
  query TagPage($tag: String!) {
    site {
      siteMetadata {
        title
      }
    }
    posts: allMarkdownRemark(
      limit: 1000
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { tags: { in: [$tag] } } }
    ) {
      edges {
        node {
          id
          excerpt
          fields {
            slug
            hero {
              childImageSharp {
                resolutions(height: 240, width: 320) {
                  src
                  srcSet
                  width
                  height
                }
              }
            }
          }
          frontmatter {
            date(formatString: "YYYY")
            title
            category
          }
        }
      }
  }
}
`


// WEBPACK FOOTER //
// ./src/templates/Tags.js